export const SearchbarActions = {
    SEARCH_TEXT_CHANGED: "SEARCH_TEXT_CHANGED",
};
